module.exports = __webpack_public_path__ + "static/media/254.aaad9890.jpg";